<script setup lang="ts">
import { useUserStore } from '@/authentication/user.store'
import { storeToRefs } from 'pinia'

const userStore = useUserStore()
const { isAuthenticated } = storeToRefs(userStore)
</script>

<template>
  <div v-if="!isAuthenticated" class="text-sm leading-[18px] text-gray-700 font-medium w-full mt-8">
    <p class="mb-3 max-w-[980px]">
      Access to content contained on this webpage is subject to you agreeing to the Goalbook
      <a
        href="https://goalbook.com/terms/"
        target="_blank"
        class="text-primary-500 underline"
      >
        Terms of Use
      </a>.
      By continuing to access and view the content on this webpage you are agreeing to the Terms of Use.
      If you do not agree to the Terms of Use, you must immediately close this webpage and discontinue any further access to it.
    </p>
  </div>
</template>
